import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "bootstrap-icons/font/bootstrap-icons.css";
import "aos/dist/aos.css";
import "./loginform.css"; 
import "./AboutPage";
import "./ContactPage";

const Login = ({ setIsAuthenticated }) => {
  const [userId, setUserId] = useState("");
  // const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  // const [isAdmin, setIsAdmin] = useState(false); 
  const [loading, setLoading] = useState(false);
  // const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.clear();
  }, []);

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError("");
      }, 2000);
    }
  }, [error]);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // 🔧 Trim values before sending
      const trimmedUserId = userId.trim();
      // const trimmedPassword = password.trim();

      const payload = { userId: trimmedUserId };

      const res = await axios.post("https://dr-backend-32ec.onrender.com/auth/login", payload);

      

      sessionStorage.setItem("token", JSON.stringify(res.data.token));
      setIsAuthenticated(true);
      navigate("/", { replace: true });
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message || "Enter valid RollNo");
      } else {
        setError("Server error, please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
     
        <div className="top-marquee text-white py-3 fixed top-0 left-0 w-full z-50 bg-black">
          <div className="flex flex-col items-center justify-center space-y-3 text-center">
            
            {/* Title */}
            <span className="text-sm sm:text-base">
              🚀 Welcome to AITAM Digital Room Management Portal — Smart, Fast, and Reliable!
            </span>
            {/*Navigation Buttons */}
            <div className="flex space-x-4 justify-center">
          <button
            className="px-4 py-2 rounded-md border border-white text-white text-xs sm:text-sm bg-transparent hover:bg-white/10 hover:shadow-md hover:scale-105 transition-all duration-300"
            onClick={() => navigate('/About')}
          >
            About
          </button>
          <button
            className="px-4 py-2 rounded-md border border-white text-white text-xs sm:text-sm bg-transparent hover:bg-white/10 hover:shadow-md hover:scale-105 transition-all duration-300"
            onClick={() => navigate('/Contact')}
          >
            Contact
          </button>
        </div>


          </div>
        </div>






      {/* Login Page Wrapper */}
      <div className="login-page-wrapper">
        <div 
          className="bg-white p-4 rounded shadow-lg text-center"
          data-aos="flip-up"
          data-aos-duration="1000"
          data-aos-delay="500"
          style={{ maxWidth: "400px", width: "100%" }}
        >
          {/* Logo */}
          <div className="mb-3">
            <img
              src="/logo2.webp"
              alt="AITAM Logo"
              className="img-fluid"
            />
          </div>

          <h2 className="mb-3 text-dark">Student Login</h2>
          {error && <p className="text-danger small">{error}</p>}

          {/* Login Form */}
          <form onSubmit={handleSubmit}>
            <div className="mb-3 input-group">
              <span className="input-group-text"><i className="bi bi-person"></i></span>
              <input
                type="text"
                className="form-control"
                placeholder="User ID"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                required
                disabled={loading}
              />
            </div>

           

            <button type="submit" className="btn btn-primary w-100" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  &nbsp;Logging in...
                </>
              ) : (
                "Login"
              )}
            </button>
          </form>

         
        </div>
      </div>
    </>
  );
};

export default Login;